<template>
    <div
        id="Container"
        class="widget-container background--card d-flex justify-content-center align-items-center"
    >
        <a
            href="#"
            @click.prevent="closeSelf"
            class="close"
        >
            <svg-rndr svg="close.svg" />
        </a>
        <div class="widget-contents DialogContent">
            <div class="widget-contents__inner DialogContentInner cancel-subscription">
                <div class=" d-flex justify-content-center mb-4">
                    <svg-rndr
                        svg="success-sign.svg"
                        :width="160"
                    />
                </div>
                <div class="form-row justify-content-center mb-4">
                    <div class="col-md-auto">
                        <h1
                            v-translate
                            v-if="cancellableSubscriptions.length === 1"
                        >Are you sure you want to cancel this subscription</h1>
                        <h1
                            v-translate
                            v-else-if="cancellableSubscriptions.length > 1"
                        >Confirm which of these subscriptions you want to cancel?</h1>
                    </div>

                </div>
                <div class="form-row justify-content-center mb-4">
                    <div class="col-md-6">
                        <ul class="cancel-subscription__list">
                            <template v-if="cancellableSubscriptions && cancellableSubscriptions.length === 1">
                                <li class="cancel-subscription__list-item cancel-subscription__list-item--single">
                                    {{ cancellableSubscriptions[0].Name }} ${{ cancellableSubscriptions[0].purchaseOption.Price__c }} {{ cancellableSubscriptions[0].purchaseOption.Name }} subs
                                </li>
                            </template>
                            <template v-else-if="cancellableSubscriptions && cancellableSubscriptions.length > 1">
                                <li
                                    v-for="(subscription, index) in cancellableSubscriptions"
                                    :key="index"
                                    class="d-flex justify-content-between cancel-subscription__list-item mb-2"
                                >
                                    <Checkbox
                                        module="Widget"
                                        :modelName="`cancelSubscriptionsCheckboxes.` + subscription.subscriptionId"
                                        :changeHandler="checkboxHandler"
                                    >
                                        <span>
                                            {{ subscription.Name }}
                                        </span>
                                    </Checkbox>

                                    <span>${{ subscription.purchaseOption.Price__c }} {{ subscription.purchaseOption.Name }} subs</span>
                                </li>
                            </template>
                            <template v-else>
                                <p v-translate>You currently have no active subscriptions available to cancel.</p>
                            </template>
                        </ul>
                    </div>
                </div>

                <div class="row justify-content-center align-items-end">
                    <div class="col-12 col-md text-center ml-md-auto">
                        <template v-if="cancellableSubscriptions && cancellableSubscriptions.length > 0">
                            <button
                                class="btn btn-hollow btn--chunky border-white border-white--lightest mr-3"
                                v-translate
                                @click.prevent="closeSelf"
                            >Changed My Mind</button>
                            <LoaderedButton
                                :content="'Confirm' | translate"
                                btnClasses="btn btn-primary"
                                :clickHandler="cancelSubscriptionsHandler"
                            />
                        </template>
                        <template v-else>
                            <button
                                class="btn btn-secondary mr-3"
                                v-translate
                                @click.prevent="closeSelf"
                            >Close</button>
                        </template>
                    </div>
                </div>

                <div class="row justify-content-center">
                    <div class="col-md-8">
                        <flash-message></flash-message>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import widgetMixin from '@M/widgets/dialog';
import { mapMutations, mapActions } from 'vuex';

export default {
    mixins: [widgetMixin],
    methods: {
        ...mapMutations('Widget', ['cancelSubscriptionChecked']),
        ...mapActions('Widget', ['cancelSubscriptions']),
        checkboxHandler(checked, key) {
            let subscriptionId = key.split('.')[1];

            this.cancelSubscriptionChecked({ subscriptionId, checked });
        },
        cancelSubscriptionsHandler() {
            this.cancelSubscriptions()
                .then(res => {
                    // @devtodo reloading subscriptions here sends a message to all active widgets which triggers the widget listener and calls the loadsubscriptions ajax call 
                    // But somewhere down the line the token is getting lost. For now we just reload user/subscriptions whenever we close a modal, but this will need revisiting
                    // this.reloadSubscriptions();

                    this.$router.push({ name: 'widget-cancelled-subscriptions-success' });
                })
        }
    },
    computed: {
        cancellableSubscriptions() {
            if (!this.subscriptions.length) return;

            return this.subscriptions.filter(subscription => {
                return subscription.status != 'Pending Cancellation' && subscription.subscriptionStatus == 'Subscribed';
            });
        }
    },
    watch: {
        cancellableSubscriptions: {
            handler: function (subscriptions, oldValue) {
                // If we have only 1 active sub, we want to set that in the store as the one to cancel since we have no checkboxes.
                if (subscriptions.length === 1) {
                    this.cancelSubscriptionChecked({ subscriptionId: subscriptions[0].subscriptionId, checked: true });
                }
            },
            immediate: true
        }
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/stages/Widgets/CancelSubscription.vue